import type { PropertyRoomTypeWithImages } from '../ImagesVideo/types';

export const ROOM_TABS = ['Details', 'Beds & size', 'Amenities', 'Images', 'Policies', 'Channel & listing'] as const;
export const DEFAULT_ROOM_TAB = ROOM_TABS[0];

export type RoomTab = (typeof ROOM_TABS)[number];

export type RoomAmenity = string | { name?: string | null };

export type OfferBuilderRoom = PropertyRoomTypeWithImages &
  Partial<{
    amenities: Array<RoomAmenity>;
    availability_threshold: string | null;
    bed_groups: Array<{
      id?: string;
      description?: string | null;
      configuration?: Array<{ type?: string; size?: string; quantity?: number }>;
    }>;
    category: string | null;
    description: string;
    has_live_cm_data: boolean | null;
    number_of_bathrooms: number | null;
    number_of_bedrooms: number | null;
    number_of_beds: Array<number> | number;
    room_policies: string | null;
    room_type_code: string | null;
    size_sqm: number | null;
    source: 'admin' | 'cm-sync' | null;
    sourceLabel: string;
  }>;
